import React from 'react';
import { Translate as T } from 'react-redux-i18n';
import { InterpolationValues } from 'types/candidateStories';

type Props = {
  value: string;
  interpolationValues?: InterpolationValues;
};

const TranslatedParagraph = ({ value, interpolationValues = {} }: Props) => {
  return (
    <p className='mb-3 text-muted' data-testid='translated-paragraph'>
      <T value={value} {...interpolationValues} />
    </p>
  );
};

export default TranslatedParagraph;
